import React, { useState } from 'react';
import { FiKey, FiLogIn, FiHome, FiArrowLeft } from 'react-icons/fi';
import CheckinManagement from '../RoomManagement/CheckinManagement';
import BookingFloors from './BookingFloors';

const BookingManagement = () => {
  const [activeTab, setActiveTab] = useState('booking');
  const [viewMode, setViewMode] = useState('floors'); // 'floors' or 'rooms'
  

  const tabs = [
    { id: 'booking', label: 'Booking Management', icon: <FiHome /> },
    { id: 'checkin', label: 'Check-in/Check-out History', icon: <FiLogIn /> }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'checkin':
        return <CheckinManagement />;
      case 'booking':
        return <BookingFloors 
          viewMode={viewMode} 
          setViewMode={setViewMode} 
        />;
      default:
        return <CheckinManagement />;
    }
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 flex items-center">
          {
            viewMode === "rooms" ? (
              <button 
                onClick={() => setViewMode('floors')}
                className="mr-2 p-2 bg-blue-100 rounded-lg hover:bg-blue-200 transition-colors cursor-pointer"
                title="Back to Floors"
              >
                <FiArrowLeft className="text-blue-600" />
              </button>
            ):(
              <FiKey className="mr-2" />
            )
          }
          Booking Management
        </h1>
        <p className="text-gray-600 mt-1">Manage guest check-ins, check-outs, and room bookings</p>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => {
                setActiveTab(tab.id)
                setViewMode('floors')
              }}
              className={`py-2 px-1 border-b-2 font-medium text-sm flex items-center ${
                activeTab === tab.id
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <span className="mr-2">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div>
        {renderContent()}
      </div>
    </div>
  );
};

export default BookingManagement;
